import request from "@/utils/request";

// 申请加入工作室
export const  applyJoinGroup =(query) =>{
    return request({
        url: "/businessservice/groupApply/join",
        method:"get",
        params: query
    })
}

// 申请列表
export const  listApplyGroup =(query) =>{
    return request({
        url: "/businessservice/groupApply/list",
        method:"get",
        params: query
    })
}

// 拒绝申请
export const  refuseApplyGroup =(query) =>{
    return request({
        url: "/businessservice/groupApply/refuse",
        method:"get",
        params: query
    })
}

// 同意申请
export const  agreeApplyGroup =(query) =>{
    return request({
        url: "/businessservice/groupApply/agree",
        method:"get",
        params: query
    })
}